import { useAuth } from '../../context/AuthContext';
import { hasCapability } from '../../utils/permissions';

/**
 * Renders children only when the user holds the permission (and, for a resource action,
 * the per-resource capability the API returned).
 *
 * It renders NOTHING when the check fails — it does not disable (UX Rule 3). This is a
 * user-experience control only; the API repeats every check authoritatively.
 *
 *   <PermissionGuard permission="DOCUMENT_DELETE" resource={doc} capability="delete">
 *     <MenuItem destructive>Delete</MenuItem>
 *   </PermissionGuard>
 */
export default function PermissionGuard({ permission, permissions, requireAll, resource, capability, feature, fallback = null, children }) {
  const { can, canAll, features } = useAuth();

  if (feature && !features?.[feature]) return fallback;

  if (permissions?.length) {
    const ok = requireAll ? canAll(permissions) : permissions.some((p) => can(p));
    if (!ok) return fallback;
  } else if (permission && !can(permission)) {
    return fallback;
  }

  if (resource && capability && !hasCapability(resource, capability)) return fallback;

  return children;
}
